<ng-container *transloco="let tr; prefix: 'operations'; scope: 'operations'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
    </nz-page-header>
  </nz-affix>

  <nz-collapse>
    <nz-collapse-panel [nzHeader]="tr('editLanAndLat')" nzActive="true">
      <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitFormLatLong()">
        <div nz-row [nzGutter]="8">
          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('form.orderId')}}</nz-form-label>
              <nz-form-control>
                <nz-input-number class="input-width-150" formControlName="orderId" [nzMin]="1" [nzSize]="'small'"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('form.deliveryLat')}}</nz-form-label>
              <nz-form-control>
                <nz-input-number class="input-width-150" formControlName="deliveryLat" [nzMin]="1" [nzSize]="'small'"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col>
            <nz-form-item>
              <nz-form-label nzRequired>{{tr('form.deliveryLong')}}</nz-form-label>
              <nz-form-control>
                <nz-input-number class="input-width-150" formControlName="deliveryLong" [nzMin]="1" [nzSize]="'small'"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col>
            <nz-form-item>
              <nz-form-label></nz-form-label>
              <nz-form-control>
                <button [nzLoading]="isLoading.model" [disabled]="form.pristine || form.pending || form.disabled" type="submit" nz-button nzType="primary">
                  <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
                </button>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </form>
    </nz-collapse-panel>
  </nz-collapse>
</ng-container>
